import script from "./Denmark-view.vue?vue&type=script&setup=true&lang=js"
export * from "./Denmark-view.vue?vue&type=script&setup=true&lang=js"

import "./Denmark-view.vue?vue&type=style&index=0&id=08821757&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08821757"]])

export default __exports__